import { ICustomsStatus, ICustomsStatusPersistence } from '../interfaces';

export class CustomsStatusMapper {
  public static toDomain(result: ICustomsStatusPersistence): ICustomsStatus {
    return {
      status: result ? 'success' : 'error',
    };
  }
}
